import { Cart } from '../../model/cart';
import { ICartButtons } from './Buttons/ICartButtons';
import selectFirstTab from '../../service/productTabs';

/**
 * @type {Cart}
 */
const shopCart = new Cart();

/**
 * @type {{init(): void, CART_PREORDER: BaseCollection, CART_WISHLIST: BaseCollection, CART: Cart}}
 */
export const IShop = {
  CART: shopCart,
  CART_PREORDER: shopCart.map.get('PreOrder'),
  CART_WISHLIST: shopCart.map.get('Wishlist'),

  init() {
    ICartButtons();
    selectFirstTab('.product-description-tabs > li.nav-item > a.nav-link', '.product-description-content > div.tab-pane');
  },
};
